<template>
  <div class="empty" :style="{ 'margin-top': marginTop }">
    <div class="empty-icon-content">
      <svg-icon icon-class="empty" :size="size"></svg-icon>
    </div>
    <div class="tips">{{ message }}</div>
  </div>
</template>
   
<script>

export default {
  props: {
    message: {
      type: String,
      default: '暂无数据'
    },
    size: {
      type: Number,
      default: 32
    },
    marginTop: {
      type: String,
      default: '20%'
    }

  },
  name: '',
  data () {
    return {
    }
  },
}
</script>
   
<style lang='scss' scoped>
.empty {
  width: 100%;
  margin: 0 auto;
  // display: flex;
  // text-align: center;
  // align-items: center;
  //   flex-direction: column;
  box-sizing: border-box;
  .empty-icon-content {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 16px;
  }
  .tips {
    color: #999;
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
    // margin: 0 auto;
  }
}
</style>